export default "__VITE_ASSET__ByWfq$HC__"